import React, { useState } from "react";
import CustomButton from "components/CustomButton";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import Scrollbar from "react-scrollbars-custom";

function SummerizerSummary({ data }) {
  const [showModal, setModal] = useState(false);

  const hide = () => {
    setModal(false);
  };

  return (
    <>
      <CustomButton
        onClick={() => setModal(true)}
        buttonClass="grad_btn summary-button"
      >
        View Details
      </CustomButton>
      <Modal
        open={showModal}
        onClose={() => hide()}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "summary-response" }}
      >
        <div className="summary-response-root">
          <div className="summary-header">
            <div className="heading">Summary</div>
            <CloseIcon onClick={hide} className="closeIcon" />
          </div>
          <div className="summary-semi-header">
            Generated Summary From Summarizer
          </div>

          <div className="summary-content">
            <Scrollbar style={{ height: "200px", fontSize: "15px" }}>
              <div>{data}</div>
            </Scrollbar>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SummerizerSummary;
